module.exports = __webpack_public_path__ + "static/media/clearIconActive.46a75d7d.svg";